
import '../css/Home.css'
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useEffect, useState, useMemo } from 'react';
import Alert from '@mui/material/Alert';
import {useNavigate} from 'react-router-dom'
import { DataGrid } from '@mui/x-data-grid';

import { TreeView } from '@mui/x-tree-view/TreeView';
import { TreeItem, treeItemClasses  } from '@mui/x-tree-view/TreeItem';
import Avatar from '@mui/material/Avatar';
import { alpha, styled } from '@mui/material/styles';
import WhiteboardIcon from '@mui/icons-material/BorderColor';
import Tooltip from '@mui/material/Tooltip';
import { isMobile } from 'react-device-detect';
import Collapse from '@mui/material/Collapse';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Settings from './Settings';
import DialogTitle from '@mui/material/DialogTitle';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useSpring, animated } from '@react-spring/web';
import IconButton from '@mui/material/IconButton';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import NoteIcon from '@mui/icons-material/Note';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import AddIcon from '@mui/icons-material/Add';
import Box from '@mui/material/Box';
import FolderIcon from '@mui/icons-material/Folder';

import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGear } from '@fortawesome/free-solid-svg-icons'

const columns = [
  {
    field: 'name',
    headerName: 'Name',
    flex: 1,
    editable: false,
  },
  {
    field: 'modified',
    headerName: 'Last modified',
    width: 200,
    editable: false,
    sortable: false,
  },
  {
    field: 'sort',
    headerName: 'Last modified',
    width: 200,
    editable: false,
  },
  {
    field: 'actions',
    headerName: 'Actions',
    width: 150,
    sortable: false,
  },
];

export default function Home(
  {
    username, 
    updateTab, 
    value, 
    allFiles,
  }) {


    useEffect(()=>{
      document.title = 'DoNotes | Home'
    })
    const navigate = useNavigate()
    const [searchTerm, setSearchTerm] = useState('');
    const [allItems, setAllItems] = useState(allFiles)
    useEffect(()=>{
      setAllItems(allFiles)
    }, [allFiles])
    const [globalNotes, setGlobalNotes] = useState([])
    const [globalWhiteboards, setGlobalWhiteboards] = useState([])
    useEffect(()=>{
      const formatDate = dateString => {
        const date = new Date(dateString);
        return date.toISOString().slice(0, 19).replace('T', ' ');
      };
  
      // Sort the data based on modified date
      const sortedData = [...allFiles].sort((a, b) => {
        return new Date(formatDate(a.modified)) - new Date(formatDate(b.modified));
      });
      setGlobalNotes(sortedData.filter(file => file.type === 'note'))
      setGlobalWhiteboards(allFiles.filter(file => file.type === 'board'))
    }, [allFiles])
    
    const [tableItems, setTableItems] = useState(globalNotes)

    function timeAgo(input) {
      const now = new Date();
      const then = new Date(input);
      
      // Convert UTC time to client's local time
      const offset = now.getTimezoneOffset() * 60 * 1000; // offset in milliseconds
      const localThen = new Date(then.getTime() + offset);
    
      const seconds = Math.floor((now - localThen) / 1000);
    
      if (seconds < 60) {
        return seconds === 1 ? '1 second ago' : 'a few seconds ago';
      }
    
      const minutes = Math.floor(seconds / 60);
      if (minutes < 60) {
        return minutes === 1 ? '1 minute ago' : `${minutes} minutes ago`;
      }
    
      const hours = Math.floor(minutes / 60);
      if (hours < 24) {
        return hours === 1 ? '1 hour ago' : `${hours} hours ago`;
      }
    
      const days = Math.floor(hours / 24);
      if (days < 7) {
        return days === 1 ? '1 day ago' : `${days} days ago`;
      }
    
      const weeks = Math.floor(days / 7);
      if (weeks < 4) {
        return weeks === 1 ? '1 week ago' : `${weeks} weeks ago`;
      }
    
      const options = { month: 'long', year: 'numeric' };
      return localThen.toLocaleDateString(undefined, options);
    }
    
    function convertToTimestamp(dateStr) {
      const date = new Date(dateStr);
      return date.getTime();
  }
  
    useEffect(()=>{
      function loadNotes() {
        
        
      let temp = []; // Initialize the array properly
      globalNotes.forEach((note) => {
        let noteObject = {}; // Create a new object for each note
        noteObject.name = note.name;
        noteObject.id = note.id
        noteObject.parent = note.parent
        noteObject.sort = convertToTimestamp(note.modified)
        noteObject.publicId = note.publicId
        noteObject.modified = timeAgo(note.modified);
        noteObject.actions = note.actions;
        temp.push(noteObject); // Push the object into the array
      });
      setTableItems(temp)
      }
      loadNotes()
      const timer = setInterval(()=>{
      loadNotes()
      }, 60000)
      return ()=>clearInterval(timer)
    }, [globalNotes])
    const notesAndBoard = [...globalNotes, ...globalWhiteboards]
    const getIcon = (type) => {
        switch (type) {
          case 'folder':
            return <FolderIcon />;
          case 'note':
            return <NoteIcon />;
          case 'board':
            return <EditIcon />;
          default:
            return null;
        }
      };
      const buildSearchTree = (items) => (
        items.filter(item => item.name.toLowerCase().includes(searchTerm.toLowerCase()) && item.type !== 'folder')

        .map(item => (
            <TreeItem
              sx={{borderRadius: 5, width: '100%'}}
              key={`${item.type}${item.id}`}
              nodeId={String(item.id)}
              label={<>
              <Box sx={{width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}
              >
                <span style={{display: 'flex', alignItems: 'center', gap: 5}}>
                    <span style={{fontSize: 'smaller'}}>
                        {getIcon(item.type)}
                    </span>
                    <span style={{display: 'flex', flexDirection: 'column', margin: 5,}}>
                      <span>
                        
                    {item.name}
                      </span>
                      
                    <span style={{fontSize: 'smaller', fontWeight: 'bold', textTransform: 'capitalize'}}>
                      {item.type}
                    </span> 
                    </span>
                </span>
              </Box>
              </>}
              onClick={(e) => {
                if (item.type === 'folder') {
                  e.stopPropagation()
                  setSearchTerm('')
                }else {
                    e.stopPropagation()
                    if(item.type === 'note') {
                      navigate(`loading`)
                      setTimeout(()=>{
                        
                      navigate(`editor/${item.id}`)
                      }, 150)
                    }else {
                        navigate(`whiteboard/${item.id}`)
                    }
                }
              }}
            >
            </TreeItem>
          ))
      );
      
    const firstFiveNotes = globalNotes.slice(0, 5);
    
  const handleRowClick = (event) => {
    navigate('editor/' + event.id)
  };
    useEffect(()=>{
        
    updateTab(value, 'Home', '/')
    }, [])
    const memoizedBuildSearchTree = useMemo(() => buildSearchTree(allItems), [buildSearchTree, allItems]);

    return( 
        <div style={{width: '100%', overflowY: 'auto', maxHeight: 'calc(100vh - 75px)'}}>
        <div className='home-container'>
            <div className='home-message'>
                <h2>
                    Hi {username} 👋
                </h2>
            </div>
            <dn-recent  >
                <dn-recent-title>
                    Recently opened
                </dn-recent-title>
                <dn-recent-tiles >
                    
        {firstFiveNotes.map(note => (
                    <Card elevation={2} style={{
                        minWidth: 100,
                        width: 250,
                        height: 150,
                        borderRadius: 10,
                        marginBottom: 10 ,
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                    key={note.id}>
                        <h3 style={{margin: 'auto'}}>{note.name}</h3>
                        <md-filled-tonal-button style={{marginTop: 'auto'}} onClick={()=>{
                          navigate(`editor/${note.id}`)}}>Open note</md-filled-tonal-button>
                    </Card>
        ))}
                </dn-recent-tiles>
            </dn-recent>
            <dn-recent  style={{
                    maxHeight: 'calc(100vh - 455px)',
                    marginTop: 10,
                    overflowY: 'auto'
                }}>
      <div style={{ display: 'flex', flexDirection: 'column' , width: '100%', alignItems: 'center'}}>
      <DataGrid
        sx={{
          width: '100%',
        }}
        height='100%'
        rows={tableItems}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 5,
            },
          },
          sorting: {
            sortModel: [{ field: 'sort', sort: 'desc' }],
          },
        }}
        pageSizeOptions={[5]}
        checkboxSelection
        disableRowSelectionOnClick
        onRowClick={handleRowClick} 
      />
    </div>    
             
            </dn-recent>

        </div>
        </div>
    )
}